import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/remotion-claude-guide/content.tsx");
